import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  margin: 40px 0px 0px 0px;
  display: flex;
  justify-content: center;

  // Logos Container
  .logos-container {
    //width: 900px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
  }

  // Logos
  .logos-container img {
    width: 21%;
    margin: 0px 24px 0px 24px;
    display: block;
    pointer-events: none;
    user-select: none;
  }

  #rus-logo,
  #colon-logo {
    width: 150px;
  }

  #atm-logo {
    width: 83.7px;
  }

  #patronal-logo {
    width: 220px;
  }

  // Marquee Container
  .fade-container-marquee {
    width: 100%;
    display: none;
    justify-content: center;
    align-items: center;
    align-content: center;

    img {
      width: 21%;
      margin: 0px 24px 0px 24px;
      display: block;
      pointer-events: none;
      user-select: none;
    }
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    margin: 90px 0px 0px 0px;
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Logos Container
    .logos-container {
      display: none;
    }

    // Marquee Container
    .fade-container-marquee {
      width: 680px;
      display: flex;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Marquee Container
    .fade-container-marquee {
      width: 100%;
    }
  }
`;

export default Container;
